import React, { useCallback, useContext, useEffect, useState } from "react";
import { DContext } from "../context/Datacontext";
import { Pagination } from "../utils/Pagination";
import { fetchCarts } from "../services/admin/fetchCarts";
import { SmartFilterBar } from "../components/common/SmartFilterBar";
import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";

export const Carts = () => {
    const { BeURL } = useContext(DContext);

    const navigate = useNavigate();

    const [carts, setCarts] = useState([]);
    const [loading, setLoading] = useState(false);

    const [selectedCart, setSelectedCart] = useState(null); // ⭐ popup state
    const [filters, setFilters] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [total, setTotal] = useState(0);



    const loadData = useCallback(async () => {
        try {
            setLoading(true);

            const res = await fetchCarts({
                BeURL,
                page,
                limit,
                ...filters
            });

            if (res?.success) {
                setCarts(res.carts || []);
                setTotalPages(res.totalPages || 1);
                setTotal(res.total || 0);
            }
        } finally {
            setLoading(false);
        }
    },[BeURL,page,limit , JSON.stringify(filters)]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const handleUser = (userId) => {
        navigate('/app/view-user', { state: { userId } });
    };

    return (
        <div className="min-h-screen bg-gray-50 p-6 space-y-5 rounded-xl border shadow-xl">

            {/* Header */}
            <div className="flex justify-between items-center">
                <h2 className="text-2xl font-bold">Cart Management</h2>
                <span className="bg-primary-100 text-primary-700 text-xs px-3 py-1 rounded-full">
                    Total: {total}
                </span>
            </div>

                        {/* 🔥 ENTERPRISE FILTER BAR */}
                        <SmartFilterBar
                            BeURL={BeURL}
                            onChange={(f) => {
                                setFilters(f);
                                setPage(1);
                            }}
                        />

            {/* Table */}
            <div className="bg-white rounded-xl shadow overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-primary-100 text-xs capitalize text-primary-600">
                        <tr>
                            <th className="p-3 border">Sl.No</th>
                            <th className="p-3 border">Student</th>
                            <th className="p-3 border">Courses Count</th>
                            <th className="p-3 border">Total</th>
                            <th className="p-3 border">Added On</th>
                            <th className="p-3 border">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {carts.map((cart, idx) => (
                            <tr key={cart._id} className="border-t">
                                <td className="p-3 border text-center">
                                    {(page - 1) * limit + idx + 1}
                                </td>

                                <td onClick={() => handleUser(cart.student?._id)} className="p-3 border text-center font-medium text-primary-600 cursor-pointer hover:underline">
                                    {cart.userFullName || cart.student?.fullName || "-"}
                                </td>

                                <td className="p-3 border text-center">
                                    {cart.courses?.length || 0}
                                </td>

                                <td className="p-3 border text-center font-semibold">
                                    ₹{cart.pricing?.totalAmount || 0}
                                </td>

                                <td className="p-3 border text-center">
                                    {new Date(cart.createdAt).toLocaleDateString("en-IN")}
                                </td>

                                {/*VIEW BUTTON */}
                                <td className="p-3 border text-center">
                                    <button
                                        onClick={() => setSelectedCart(cart)}
                                        className=" text-primary-700 rounded-lg text-xs"
                                    >
                                        <GrView size={20} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <Pagination
                page={page}
                totalPages={totalPages}
                limit={limit}
                totalUsers={total}
                setPage={setPage}
                setLimit={setLimit}
            />

            {/* ================= POPUP MODAL ================= */}
            {selectedCart && (
                <div className="fixed inset-0 bg-primary-100/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">

                    {/* Modal Card */}
                    <div className="bg-white w-full max-w-3xl max-h-[85vh] overflow-y-auto rounded-2xl shadow-2xl p-8 space-y-6 animate-fadeIn">

                        {/* ================= HEADER ================= */}
                        <div className="flex justify-between items-center border-b pb-4">
                            <div>
                                <h3 className="text-2xl font-bold text-gray-800">
                                    Cart Details
                                </h3>
                                <p className="text-sm text-gray-500">
                                    Student purchase overview
                                </p>
                            </div>

                            <button
                                onClick={() => setSelectedCart(null)}
                                className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 hover:bg-red-100 text-gray-500 hover:text-red-600 transition"
                            >
                                ✕
                            </button>
                        </div>

                        {/* ================= STUDENT INFO ================= */}
                        <div className="bg-gray-50 rounded-xl p-4 grid grid-cols-2 gap-4 text-sm">
                            <div>
                                <p className="text-gray-500">Name</p>
                                <p className="font-semibold text-gray-800">
                                    {selectedCart.userFullName}
                                </p>
                            </div>

                            <div>
                                <p className="text-gray-500">Email</p>
                                <p className="font-semibold text-gray-800">
                                    {selectedCart.email}
                                </p>
                            </div>

                            <div>
                                <p className="text-gray-500">Contact</p>
                                <p className="font-semibold text-gray-800">
                                    {selectedCart.contact}
                                </p>
                            </div>
                        </div>

                        {/* ================= COURSE LIST ================= */}
                        <div>
                            <h4 className="text-lg font-semibold mb-3 text-gray-800">
                                Courses Enrolled
                            </h4>

                            <div className="space-y-3">
                                {selectedCart.courses?.map((c, i) => (
                                    <div
                                        key={i}
                                        className="flex items-center gap-4 bg-white border rounded-xl p-4 hover:shadow-md transition"
                                    >
                                        <img
                                            src={c.thumbnail}
                                            alt=""
                                            className="w-20 h-14 object-cover rounded-lg"
                                        />

                                        <div className="flex-1">
                                            <p className="font-semibold text-gray-800">
                                                {c.title}
                                            </p>

                                            <p className="text-xs text-gray-400 mt-1">
                                                Code: {c.code || String(c.id).slice(0, 6)}
                                            </p>
                                        </div>

                                        <div className="text-right">
                                            {c.price && c.discountPrice && (
                                                <p className="text-xs line-through text-gray-400">
                                                    ₹{c.price}
                                                </p>
                                            )}
                                            <p className="text-lg font-bold text-indigo-600">
                                                ₹{c.finalPrice ?? c.discountPrice ?? c.price}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* ================= PRICING SUMMARY ================= */}
                        <div className="bg-indigo-50 rounded-2xl p-6 space-y-3 border">
                            <div className="flex justify-between text-sm text-gray-700">
                                <span>Subtotal</span>
                                <span>₹{selectedCart.pricing?.subtotal}</span>
                            </div>

                            <div className="flex justify-between text-sm text-green-600">
                                <span>Discount</span>
                                <span>- ₹{selectedCart.pricing?.discount}</span>
                            </div>

                            <div className="border-t pt-3 flex justify-between text-lg font-bold text-gray-900">
                                <span>Total Amount</span>
                                <span>₹{selectedCart.pricing?.totalAmount}</span>
                            </div>
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
};